// Detectar si estamos en desarrollo local
const isLocalDevelopment = import.meta.env.DEV || window.location.hostname === 'localhost';
const API_BASE_URL = isLocalDevelopment 
  ? 'http://localhost:3000' 
  : (import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000');

// Función para construir URLs completas
export const buildApiUrl = (endpoint) => {
  // Validar que endpoint no sea undefined o null
  if (!endpoint) {
    console.error('❌ buildApiUrl: endpoint es undefined o null');
    throw new Error('El endpoint no puede ser undefined o null');
  }
  
  console.log('🔗 buildApiUrl:', { 
    endpoint, 
    API_BASE_URL, 
    VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL 
  });
  
  // Si el endpoint ya es una URL completa, la devolvemos tal como está
  if (endpoint.startsWith('http://') || endpoint.startsWith('https://')) {
    console.log('✅ buildApiUrl: URL completa detectada:', endpoint);
    return endpoint;
  }
  
  // Si el endpoint comienza con /, lo concatenamos con la base URL
  if (endpoint.startsWith('/')) {
    const fullUrl = `${API_BASE_URL}${endpoint}`;
    console.log('✅ buildApiUrl: URL construida:', fullUrl);
    return fullUrl;
  }
  
  // Si no, agregamos el / antes de concatenar
  const fullUrl = `${API_BASE_URL}/${endpoint}`;
  console.log('✅ buildApiUrl: URL construida con /:', fullUrl);
  return fullUrl;
};

// URLs de endpoints comunes
export const API_ENDPOINTS = {
  AUTH: '/api/admin/auth',
  EMPLOYEES: '/api/admin/employees',
  USERS: '/api/admin/users',
  AGENCIES: '/api/admin/agencies',
  CUSTOMERS: '/api/admin/customers',
  VEHICLES: '/api/admin/vehicles',
  VEHICLE_MODELS: '/api/admin/vehicle-models',
  VEHICLE_CATEGORIES: '/api/admin/vehicle-categories',
  BOOKINGS: '/api/admin/bookings',
  ACTIVITIES: '/api/admin/activities',
  FACTURACION: '/api/admin/facturacion',
  MAINTENANCES: '/api/admin/maintenances',
  AVAILABILITY_BLOCKS: '/api/admin/availability-blocks',
  ACCESSORIES: '/api/admin/accessories',
  SEASONS: '/api/admin/seasons',
  SEASON_PRICES: '/api/admin/season-prices',
  CONTRACTS: '/api/contracts',
  SETTINGS: '/api/admin/settings',
  CLOSED_DAYS: '/api/admin/closed-days',
  /** Público (sin prefijo admin) — mismo backend */
  PAYMENT_CREATE_INTENT: '/payment/create-intent',
  PAYMENT_CONFIRM: '/payment/confirm'
};

export default API_BASE_URL; 